import { DEFAULTS } from './';

export const FONT_FAMILY = [
  {
    label: 'Default',
    value: DEFAULTS.FONT_FAMILY,
  },
  {
    label: 'Old Style',
    value: 'var(--RS__oldStyleTf)',
  },
  {
    label: 'Modern',
    value: 'var(----RS__modernTf)',
  },
  {
    label: 'Sans',
    value: 'var(--RS__sansTf)',
  },
  {
    label: 'Humanist',
    value: 'var(--RS__humanistTf)',
  },
  {
    label: 'Monospace',
    value: 'var(--RS__monospaceTf)',
  },
  {
    label: 'OpenDyslexic',
    value: 'OpenDyslexic, sans-serif',
  },
];

export const FONT_SIZE = [
  {
    label: '20%',
    value: 0.2,
  },
  {
    label: '40%',
    value: 0.4,
  },
  {
    label: '60%',
    value: 0.6,
  },
  {
    label: '80%',
    value: 0.8,
  },
  {
    label: '100%',
    value: 1,
  },
  {
    label: '120%',
    value: 1.2,
  },
  {
    label: '140%',
    value: 1.4,
  },
  {
    label: '160%',
    value: 1.6,
  },
  {
    label: '180%',
    value: 1.8,
  },
  {
    label: '200%',
    value: 2,
  },
];

export const MAX_FONT_SIZE_VALUE = Math.max(...FONT_SIZE.map((o) => o.value));
export const MIN_FONT_SIZE_VALUE = Math.min(...FONT_SIZE.map((o) => o.value));

export const LETTER_SPACING = [
  {
    label: 'Default',
    value: DEFAULTS.LETTER_SPACING,
  },
  {
    label: 'Tight',
    value: -0.05,
  },
  {
    label: 'Loose',
    value: 0.1,
  },
];

export const LINE_HEIGHT = [
  {
    label: 'Default',
    value: DEFAULTS.LINE_HEIGHT,
  },
  {
    label: '1.5',
    value: 1.5,
  },
  {
    label: '2.5',
    value: 2.5,
  },
];

export const PAGE_MARGIN = [
  {
    label: 'Default',
    value: DEFAULTS.PAGE_MARGIN,
  },
  {
    label: 'Narrow',
    value: DEFAULTS.PAGE_MARGIN * 0.5,
  },
  {
    label: 'Wide',
    value: DEFAULTS.PAGE_MARGIN * 2,
  },
];

export const THEME_DEFAULT = DEFAULTS.THEME;
export const THEME_SEPIA = 1;
export const THEME_NIGHT = 2;
export const THEME_HIGH_CONTRAST = 3;

export const THEME = [
  {
    label: 'Default',
    value: THEME_DEFAULT,
  },
  {
    label: 'Sepia',
    value: THEME_SEPIA,
  },
  {
    label: 'Night',
    value: THEME_NIGHT,
  },
  {
    label: 'High Color Contrast',
    value: THEME_HIGH_CONTRAST,
  },
];
